import { render, staticRenderFns } from "./add-table-dialog.vue?vue&type=template&id=9bda299e&scoped=true"
import script from "./add-table-dialog.vue?vue&type=script&lang=js"
export * from "./add-table-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-table-dialog.vue?vue&type=style&index=0&id=9bda299e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bda299e",
  null
  
)

export default component.exports